<!--
 * @Author: jackshen
 * @Date: 2021-07-08 09:44:41
 * @LastEditors: wenlin
 * @LastEditTime: 2021-07-08 18:43:01
 * @Description:
-->
<template>
  <div class="case_container">
    <common-banner :imgSrc="img.path" :imgLabel="img.label" :path="''" @click.native="detailFlag=false" :imgType='"scroll"'></common-banner>
    <div v-if="!detailFlag" style="text-align: center; color: #8c939d;">
      <p>* 点击以下各维度获取相关案例</p>
    </div>
    <!-- <div class="change_btn" v-if="!detailFlag" @change="init()">
      <el-radio-group v-model="val" fill='#009844' text-color='#fff'>
        <el-radio-button :label="'pro'">省域指标</el-radio-button>
        <el-radio-button :label="'city'">城市指标</el-radio-button>
      </el-radio-group>
    </div> -->
    <div class="menu_box">
        <div class="column_text" @click="toDetail(positionList[0],0)" style="background-color:#C4D42B">利用层案例</div>
        <div class="column_text" @click="toDetail(positionList[1],1)" style="background-color:#45A638">数据层案例</div>
        <div class="column_text" @click="toDetail(positionList[2],2)" style="background-color:#1791CC">服务层案例</div>
        <div class="column_text" @click="toDetail(positionList[3],3)" style="background-color:#262678">准备度案例</div>
    </div>
    <div class="main_content" v-if="!detailFlag">
      <img :src="require('@/assets/images/logo1.svg')"
           alt="" style="width: 65%">
      <!-- <div v-for="(item,index) in tagList" :key="index"
           :style="{width:'210px',height:positionList[4]['height'],left:'64%',top:positionList[5]['top'],position:'absolute',cursor:'pointer'}"
           @click="toDetail(item,index)"></div> -->
           <div v-for="(item,index) in positionList" :key="index"
           :style="{width:'210px',height:item.height,left:'64%',top:item['top'],position:'absolute',cursor:'pointer'}"
           @click="toDetail(item,index)"></div>
    </div>
    <!-- 案例库页面 -->
    <CaseDetail :caseItem='currentItem' v-if="detailFlag" :region='val' @closeDetail='detailFlag=false' ref="detailDia"/>
    <div class="backtop"></div>
    <el-backtop target=".case_container .backtop"></el-backtop>
  </div>
</template>
<script>
    import CommonBanner from '@/pages/common/Banner'
    import {
        getTags,
        points
    } from '@/api/case'
    import CaseDetail from './components/caseDetail'
    // import CommonMain from '@/pages/common/Main'
    export default {
        name: 'Case',
        components: {
            CommonBanner,
            CaseDetail
        },
        data() {
            return {
                img: {
                    path: require('@/assets/images/banner/cases_banner.jpg'),
                    label: '开放数林'
                },
                val: 'pro',
                tagList: [],
                positionList: [{
                    label: '利用层案例',
                    val: 1,
                    width: '200px',
                    height: '70px',
                    left: '50%',
                    top: '10%'
                }, {
                    label: '数据层案例',
                    val: 2,
                    width: '200px',
                    height: '70px',
                    left: '50%',
                    top: '35%'
                }, {
                    label: '服务层案例',
                    val: 3,
                    width: '200px',
                    height: '70px',
                    left: '50%',
                    top: '60%'
                }, {
                    label: '准备度案例',
                    val: 4,
                    width: '200px',
                    height: '70px',
                    left: '50%',
                    top: '78%'
                }],
                currentItem: {},
                detailFlag: false,
                loading: null
            }
        },
        created() {
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        mounted() {
            points()
            this.loading.close();
        },
        methods: {
            // init() {
            //     let me = this
            //     let obj = {
            //         region: this.val
            //     }
            //     getTags(0, obj).then(res => {
            //         // console.log(res)
            //         if (res.retCode === 0) {
            //             // me.tagList = res.data
            //             res.data.forEach((item, index) => {
            //                 console.log(index)
            //                 if (item['level'] === 1) {
            //                     me.tagList.push(item)
            //                 }
            //             //    me.positionList[4]['tagId'] = me.tagList[0]['tagId']
            //             })
            //             console.log(me.tagList)
            //                 // for(let i in res.data){
            //                 //   console.log(i)
            //                 //   me.positionList[i+4]['tagId']=res.data[i]['tagId']
            //                 // }
            //             me.$store.dispatch('set_menu', res.data)
            //         }

            //         console.log(me.positionList)
            //     })
            // },
            // 跳转案例页面
            toDetail(item, index) {
                // console.log(item)
                this.currentItem = item


                this.detailFlag = true
                setTimeout(() => {
                    this.$refs.detailDia.init('')
                }, 200)

            }
        }
    }
</script>
<style>

</style>

<style scoped>
    html,
    body {
        height: 100%;
    }

    #app {
        height: 100%;
    }

    .backtop {
        overflow: scroll;
        height: 100%;
    }

    .case_container {
        overflow: hidden;
        height: 100%;
        position: relative;
    }

    .menu_box {
        /* width: 150px; */
        height: 600px;
        /* background: rgba(0, 0, 0, 0.7); */
        position: absolute;
        left: 0;
        top: 450px;
        z-index: 10;
    }

    .column_text {
        width: 20px;
        cursor: pointer;
        padding: 5px 10px;
        font-weight: 600;
        margin: 0 auto 15px;
        line-height: 24px;
        color: #fff;
        background: rgba(0, 0, 0, 0.7);
    }

    .change_btn {
        width: fit-content;
        margin: 20px auto 10px;
        /* background: #009844; */
    }

    .main_content {
        text-align: center;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/pages/casePage/CasePage.vue